import Udesk from 'Udesk';
import SdkLoaderBase from '../../../common/sdk-loader-base';
import UdeskLocales from 'UdeskLocales';

class SocialMediaSentimentComponent extends SdkLoaderBase {
    privates = {
        renderContainerId: 'data-analysis-social-media-sentiment',
        pageTitle: /* 社媒舆情 */UdeskLocales['current'].pages.dataAnalysis.socialMediaSentiment.index.socialMediaPublicOpinion,
    };
}

export default Udesk.react.udeskify(SocialMediaSentimentComponent);
